<template>
  <div class="activity-section" ref="self">
      <img :src="images.activity" @load="emitReady">
      <div class="activity-list">
          <div class="activity-item" v-for="item of list" :key="item.id" @click="gotoDetail(item)">
            <div class="pic">
                <img :src="item.pic || images.activityPic">
            </div>
            <div class="content">
                <div class="title">{{ item.title }}</div>
                <div class="date">时间 :  {{ item.date }}</div>
                <div class="address">地点 :  {{ item.address }}</div>
            </div>
            <span class="sign-btn" @click="handleSign(item)">立即报名</span>
          </div>
      </div>
  </div>
</template>

<script>
import images from '@/utils/images.js'
import active from './active.js'
import request from '@/utils/request.js'
// import base64js from 'base64-js'
import sha1 from 'sha1'
import { Base64 } from 'js-base64';
export default {
    mixins: [active],
    data () {
        return {
            index: 4,
            images: images,
            list: []
        };
    },
    created() {
        // window.base64 = base64js;
        const timestamp = this.getTimestamp();
        const appId = 'fmba';
        const appKey = 'fc6870794fbf8d36bca88f59b0bfa933157eb4d3';
        const signature = sha1(appId + appKey + timestamp);
        const token = Base64.btoa(appId + ',' + timestamp + ',' + signature);
        request({
            url: '/FMBAAdmission/api/getRegistrationActivities',
            headers: {
                token,
                signature,
                timestamp
            },
            method: 'post'
        }).then(res => {
            console.log(res)
            
            this.list = (res.data.data || []).map((item, index) => {
                return {
                    id: index,
                    pic: item.eventsharepicurl,
                    title: item.subject,
                    date: item.term_date,
                    address: item.venue,
                    registerurl: item.registerurl
                };
            });

            // 调用父组件的方法
            this.$parent.getOffsetTops();
            // throw '';
        }).catch(err => {
            console.log(err)
            // this.list = [{
            //     id: 1,
            //     pic: '',
            //     title: '财务观、业绩观观要端正',
            //     date: '2019年3月16号',
            //     address: '中欧上海小区'
            // }, {
            //     id: 2,
            //     pic: '',
            //     title: '财务观、业绩观和分享观：企业活下去，三观要端正',
            //     date: '2019年3月16号',
            //     address: '中欧上海小区'
            // }, {
            //     id: 3,
            //     pic: '',
            //     title: '财务观、业绩观和分享观：企业活下去，三观要端正',
            //     date: '2019年3月16号',
            //     address: '中欧上海小区'
            // }, {
            //     id: 4,
            //     pic: '',
            //     title: '财务观、业绩观和分享观：企业活下去，三观要端正',
            //     date: '2019年3月16号',
            //     address: '中欧上海小区'
            // }]
        })
    },
    methods: {
        gotoDetail (item) {
            // TODO: 跳转到活动详情
            console.log(item)
        },
        getTimestamp() {
            return parseInt(Date.now() / 1000);
        },
        handleSign(item) {
            location.href = item.registerurl;
        }
    }
}
</script>

<style lang="scss" scoped>
.activity-section {
    background: #E7E9E9;
    padding-bottom: 72px;

    .activity-list {
        padding: 0 30px;
        .activity-item {
            padding: 26px 16px;
            display: flex;
            background: #fff;
            text-align: left;
            position: relative;

            .pic {
                // flex: 0;
                flex-shrink: 0;
                flex-basis: 160px;
            }

            .content {
                padding: 0 18px;
                .title {
                    font-size: 30px;
                    color: #000;
                    // height: 88px;
                    overflow: hidden;
                }
                .date, .address {
                    font-size: 22px;
                    color: #888888;
                    line-height: 36px;
                }
                .address {
                    margin-right: 120px;
                }

                .date {
                    margin-top: 16px;
                }
            }

            .sign-btn {
                display: inline-block;
                color: #fff;
                background: #A98057;
                padding: 6px 18px;
                font-size: 20px;
                position: absolute;
                right: 20px;
                top: 50%;
                // transform: translateY(-50%);
                line-height: 1.8;
                border-radius: 50px;
            }
        }

        .activity-item + .activity-item {
            margin-top: 32px;
        }
    }
}
</style>